var _circle, _circle2, _path, _circle3, _g, _path2, _circle4, _circle5, _path3, _circle6, _g2, _path4, _circle7, _circle8, _path5, _circle9, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCoinsIcon = function SvgCoinsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 16,
    height: 16,
    x: 19,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 13,
    r: 8,
    fill: "#FEC807"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 13,
    r: 8,
    fill: "#FEC807"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "M15.69 12.309 26.258 1.742l3.394 3.394-10.566 10.567-3.395-3.394Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 12,
    height: 12,
    x: 21,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 13,
    r: 5.6,
    fill: "#FEC807"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEC807",
    d: "M32.6 13a5.6 5.6 0 1 1-11.2 0 5.6 5.6 0 0 1 11.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M27 16.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm0 2a5.6 5.6 0 1 0 0-11.2 5.6 5.6 0 0 0 0 11.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "M21.4 20.2 34.2 7.4l2.828 2.828-12.8 12.8L21.4 20.2Z",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M27 16.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm0 2a5.6 5.6 0 1 0 0-11.2 5.6 5.6 0 0 0 0 11.2Z",
    clipRule: "evenodd"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 12c0 .227-.005.453-.016.677a12.039 12.039 0 0 1 6.733 5.919 8 8 0 1 1-8.345-13.154A13.94 13.94 0 0 1 26 12Z",
    clipRule: "evenodd",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 20,
    height: 20,
    x: 12,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 10,
    fill: "#FEC807"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 10,
    fill: "#FEC807"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "M7.863 23.136 21.072 9.928l4.242 4.243-13.208 13.208-4.243-4.243Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 14,
    height: 14,
    x: 15,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 7,
    fill: "#FEC807"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEC807",
    d: "M29 24a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M22 28.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 2.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "m15 33 16-16 3.535 3.536-16 16L15 33Z",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M22 28.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 2.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    clipRule: "evenodd"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.736 14.721C24.482 21.088 18.912 25.905 12.2 26c-.131-.646-.2-1.315-.2-1.999 0-5.523 4.477-10 10-10 1.32 0 2.582.256 3.736.721Z",
    clipRule: "evenodd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FEC807"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FEC807"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "m-4.964 10.964 15.85-15.85 5.091 5.09-15.85 15.85-5.091-5.09Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.4,
    fill: "#FEC807"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEC807",
    d: "M20.4 12a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M12 17.4a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8Zm0 3a8.4 8.4 0 1 0 0-16.8 8.4 8.4 0 0 0 0 16.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA56",
    fillRule: "evenodd",
    d: "M3.6 22.8 22.8 3.6l4.243 4.243-19.2 19.2L3.6 22.8Z",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEB13D",
    fillRule: "evenodd",
    d: "M12 17.4a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8Zm0 3a8.4 8.4 0 1 0 0-16.8 8.4 8.4 0 0 0 0 16.8Z",
    clipRule: "evenodd"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 11.2,
    height: 11.2,
    x: 21.4,
    y: 7.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_6208_22603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 14,
    height: 14,
    x: 15,
    y: 17,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_6208_22603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 16.8,
    height: 16.8,
    x: 3.6,
    y: 3.6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_6208_22603"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCoinsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "coins-icon.ae6cbc7cc118012a43cf8ba33c65157b.svg";